<template>
    <ModalConfirm
        id="modal-confirm-request-kas-kecil"
        title="Konfirmasi Ajukan CA"
        desc="Apakah Anda yakin ingin mengajukan CA untuk cabang ini?"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-request-ca",
    props: {
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
